import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import moment from 'moment';

import {currentResource} from '../../../../../util/utils';

import {getRisks} from '../../../../../actions/GroupRiskAssessment';
import ExportWithTopDetails from '../../../../Common/ExportToExcel/ExportWithTopDetails';
import {RISKS_FILE_NAME, FILE_NAME_DATE_FORMAT, riskHeaders} from './utils/constants';

import {
    getAccountTypeName,
    getInherentRiskTypeName,
    getControlRiskTypeName,
    getRiskTypeName,
    getTaskStatusName
} from '../../../CreateProjectGRA/GenerateExcelCommon/Utils';

const GenerateGroupRiskAssessmentExcel = () => {
	const dispatch = useDispatch();
	const dashboardContext = useSelector((store) => store.dashboardContext);
	const project = useSelector((store) => store.project);
	const risks = useSelector((store) => store.risks);
	const [dataReceived, setDataReceived] = useState(true);
	const exportToExcelLabels = currentResource.exportToExcelLabels;
	//Need this to specificaly handle the delay in redux getting updated after api call (api call is being made on click of export) and getting updated data in exported file.
	useEffect(() => {
		setDataReceived(true);
	}, [risks]);

	const getExportDetails = () => {
		return {
			projectName: project.name,
			fileName: `${project.name}${RISKS_FILE_NAME}${moment()
				.utc()
				.format(FILE_NAME_DATE_FORMAT)}`,
			title: exportToExcelLabels.risks.tabTitle,
			columns: getColumnsToExport(),
			data: getDataToExport(),
			worksheetName: exportToExcelLabels.risks.tabTitle
		};
	};

	const getColumnsToExport = () => {
		let columns = [];
		columns.push({header: exportToExcelLabels.risks.columns.engagementName, key: riskHeaders.engagementDescription});
		columns.push({header: exportToExcelLabels.risks.columns.engagementId, key: riskHeaders.canvasEngagementId});
		columns.push({header: exportToExcelLabels.risks.columns.accountName, key: riskHeaders.accountName});
		columns.push({header: exportToExcelLabels.risks.columns.pspIndex, key: riskHeaders.pspIndexTitle});
		columns.push({header: exportToExcelLabels.risks.columns.accountType, key: riskHeaders.accountTypeId});
		columns.push({header: exportToExcelLabels.risks.columns.assertion, key: riskHeaders.assertionName});
		columns.push({header: exportToExcelLabels.risks.columns.inherentRisk, key: riskHeaders.inherentRiskTypeName});
		columns.push({header: exportToExcelLabels.risks.columns.controlRisk, key: riskHeaders.controlRiskTypeName});
		columns.push({header: exportToExcelLabels.risks.columns.craValue, key: riskHeaders.craValue});
		columns.push({header: exportToExcelLabels.risks.columns.riskType, key: riskHeaders.riskTypeName});
		columns.push({header: exportToExcelLabels.risks.columns.riskName, key: riskHeaders.riskName});
		columns.push({header: exportToExcelLabels.risks.columns.relatedTasks, key: riskHeaders.relatedTasks});
		columns.push({header: exportToExcelLabels.risks.columns.taskStatus, key: riskHeaders.taskStatus});
		return columns;
	};

	const getDataToExport = () => {
		let data = [];
		risks?.forEach((element) =>
			data.push({
				engagementDescription: element.engagementDescription,
				canvasEngagementId: element.canvasEngagementId,
				accountName: element.accountName,
				pspIndexTitle: element.pspIndexTitle,
				accountTypeId: getAccountTypeName(element.accountTypeId),
				assertionName:
					(element.assertionName === undefined ? '' : element.assertionName) +
					(element.assertionAbbreviation === undefined ? '' : ' (' + element.assertionAbbreviation + ')'),
				inherentRiskTypeName: getInherentRiskTypeName(element.inherentRiskTypeId),
				controlRiskTypeName: getControlRiskTypeName(element.controlRiskTypeId),
				craValue: element.craValue,
				riskTypeName: getRiskTypeName(element.riskTypeId),
				riskName: element.riskName,
				relatedTasks:
					(element.taskTypeId === undefined ? '' : element.taskTypeId) +
					(element.taskNamePrefix === undefined ? '' : '|' + element.taskNamePrefix) +
					(element.knowledgeTaskTitle === undefined
						? element.taskName === undefined
							? ''
							: '|' + element.taskName
						: '|' + element.knowledgeTaskTitle) +
					(element.taskNameSuffix === undefined ? '' : '|' + element.taskNameSuffix),
				taskStatus: getTaskStatusName(element.taskStatusId)
			})
		);

		return data;
	};

	const getRiskData = () => {
		dispatch(
			getRisks(
				project.projectId,
				dashboardContext.entities.map((e) => e.entityId)
			)
		);
		setDataReceived(false);
	};

	const prop = {
		getDataToExport: getExportDetails,
		buttonTitle: exportToExcelLabels.risks.exportButtonTitle,
		labels: exportToExcelLabels,
		requestData: getRiskData,
		dataReceived: dataReceived
	};

	return project.projectId !== undefined && <ExportWithTopDetails {...prop} />;
};

export default GenerateGroupRiskAssessmentExcel;
